import { render } from "./AutoForm.vue?vue&type=template&id=55be9ddb"
import script from "./AutoForm.vue?vue&type=script&lang=js"
export * from "./AutoForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__